<div [class.active]="isActive" [class.dark]='color === "dark"' class="hamburger" id="hamburger-btn">
  <div class="lines">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</div>
